import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { computeDashboardStats, StatCards } from "./StatCards";
import { RecentActivity } from "./RecentActivity";
import { AttentionPanel } from "./AttentionPanel";
export function DashboardPage() {
    const { data: mailboxes = [] } = useQuery({
        queryKey: ["mailboxes"],
        queryFn: async () => (await api.get("/mailboxes")).data,
        staleTime: 30_000,
    });
    const { data: backups = [] } = useQuery({
        queryKey: ["backups"],
        queryFn: async () => (await api.get("/backups")).data,
        staleTime: 30_000,
        refetchInterval: 30_000,
    });
    const { data: storage } = useQuery({
        queryKey: ["storage"],
        queryFn: async () => (await api.get("/storage")).data,
        staleTime: 120_000,
        refetchInterval: 120_000,
    });
    const stats = computeDashboardStats(mailboxes, backups, storage);
    return (_jsxs("div", { className: "flex flex-col gap-6", children: [_jsx(StatCards, { stats: stats }), _jsx(RecentActivity, { backups: backups }), _jsx(AttentionPanel, { backups: backups })] }));
}
